<template lang="pug">
  div
    h6 標籤清單
    vuetable(ref="vuetable"
    :api-url="`${server}/api/system/?type=Tag`"
    data-path="results"
    pagination-path=""
    :fields="fields"
    :api-mode="true"
    :css="boostrapCss"
    :http-options="httpOptions"
    detail-row-component="tag-detail"
    @vuetable:cell-clicked="onCellClicked")
      //- <template slot="actions" scope="props">
      //-   <div class="table-button-container">
      //-       <button class="ui button" @click="editRow(props.rowData)"><i class="fa fa-edit"></i> Edit</button>&nbsp;&nbsp;
      //-       <button class="ui basic red button" @click="deleteRow(props.rowData)"><i class="fa fa-remove"></i> Delete</button>&nbsp;&nbsp;
      //-   </div>
      //- </template>
    vuetable-pagination(
      ref="pagination" 
      :css="boostrapCss.pagination"
      @vuetable-pagination:change-page="onChangePage" 
    )
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import Vuetable from 'vuetable-2/src/components/Vuetable';
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination';
import readCookie from '@/vuex/functions/readCookie';
import server from '@/config';
import TagDetail from './TagDetail';

Vue.component('tag-detail', TagDetail);

export default {
  name: 'TagList',
  data() {
    return {
      boostrapCss: {
        tableClass: 'table table-striped table-bordered table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        },
      },
      httpOptions: {
        headers: {
          Authorization: `Token ${readCookie('Token')}`,
        },
      },
      server,
      fields: [
        {
          name: 'name',
          title: '名稱',
        },
        {
          name: 'area.name',
          title: '所屬區域',
        },
        {
          name: 'area.department.name',
          title: '所屬單位',
        },
        {
          name: 'admin.username',
          title: '管理者',
        },
      ],
    };
  },
  components: {
    Vuetable,
    VuetablePagination,
  },
  methods: {
    onCellClicked(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.id);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
  },
  // computed: mapState({
  //   system: state => state.system,
  // }),
};
</script>




// WEBPACK FOOTER //
// TagList.vue?7e81ef8f